export default __webpack_public_path__ + "static/media/hero-1.72c2218e.jpg";